(function() {
    angular.module('ngmvac').controller('voucherController', VoucherController);
    VoucherController.$inject = ['$scope', '$window', '$filter', '$timeout'];

    function VoucherController($scope, $window, $filter, $timeout) {
        var vm = this;
        vm.cincoLux     = '5LUX';
        vm.cincoEst     = '5EST';
        vm.cuatroLux    = '4LUX';
        vm.cuatroEst    = '4EST';
        vm.h3_5         = 'H3_5';
        vm.tresEst      = '3EST';
        vm.h2_5         = 'H2_5';
        vm.dosEst       = '2EST';
        vm.h1_5         = 'H1_5';
        vm.unoEst       = '1EST';

    }
})();